import { createSlice } from "@reduxjs/toolkit";
import {
  getDelegateAccesUserDetailThunk,
  addDelegateAccessThunk,
} from "../thunks/delegateAccessThunk";

const initialState = {
  delegatedAccessUser: null,
  delegatedAccessInfo: null,
  delegatedAccessVersion: 0,
  loading: false,
  error: null,
};

export const delegateAccessSlice = createSlice({
  name: "delegateAccess",
  initialState,

  reducers: {
    resetDelegateAccess: () => initialState,
    bumpDelegatedAccessVersion: (state) => {
      state.delegatedAccessVersion += 1;
    },
  },

  extraReducers: (builder) => {
    builder

      // 🔹 Fetch delegate user detail
      .addCase(getDelegateAccesUserDetailThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDelegateAccesUserDetailThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.delegatedAccessUser = action.payload?.data || action.payload;
      })
      .addCase(getDelegateAccesUserDetailThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message;
      })

      // 🔹 Add delegate access
      .addCase(addDelegateAccessThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addDelegateAccessThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.delegatedAccessInfo = action.payload?.data || action.payload;
      })
      .addCase(addDelegateAccessThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message;
      });
  },
});

export const { resetDelegateAccess, bumpDelegatedAccessVersion } =
  delegateAccessSlice.actions;
export const delegateAccessReducer = delegateAccessSlice.reducer;
